<template>
  <div>
    <v-form class="shop-form" ref="form" v-model="formValid">
      <v-text-field
        name="shopNameTH"
        label="ชื่อร้านค้าของคุณ (ภาษาไทย) *"
        v-model="formData.nameTH"
        :rules="formRules.required"
        outlined
        required
      ></v-text-field>
      <v-text-field
        name="shopNameEN"
        label="ชื่อร้านค้าของคุณ (ภาษาอังกฤษ) *"
        v-model="formData.nameEN"
        :rules="formRules.required"
        outlined
        required
      ></v-text-field>
      <image-uploader
        description="อัปโหลดภาพโลโก้ร้านค้า"
        :imageUrl="formData.logoImageUrl"
        :size="120"
        :isCircle="false"
        @imageBlobUpdate="(img) => (logo = img)"
      />
      <div v-if="shopId" class="tw-flex tw-justify-between tw-my-8">
        <v-btn
          color="error"
          outlined
          :disabled="saving"
          :loading="deleting"
          @click="isDeleteDialogOpen = true"
        >
          <img class="tw-mr-2" src="/images/icons/delete.svg" />
          ลบร้านค้า
        </v-btn>
        <v-btn
          color="primary"
          :loading="saving"
          :disabled="deleting"
          @click="onSave()"
        >
          บันทึก
        </v-btn>
      </div>
      <div v-else class="tw-text-right tw-my-8">
        <v-btn color="primary" text :loading="saving" @click="onSave()">
          <v-icon left>mdi-plus-circle-outline</v-icon>
          สร้างร้านค้า
        </v-btn>
      </div>
    </v-form>

    <!-- delete shop dialog -->
    <shop-delete-dialog
      v-if="isDeleteDialogOpen"
      v-model="isDeleteDialogOpen"
      :companyId="companyId"
      :shopId="shopId"
      :shop="shop"
      @success="onDeleteSuccess()"
    />
  </div>
</template>

<script>
import ImageUploader from '../../form/image-uploader.vue'
import ShopDeleteDialog from './shop-delete-dialog.vue'
import { mapState } from 'vuex'

const DEFAULT_FORM = {
  nameEN: '',
  nameTH: '',
  logoImageUrl: null,
}

export default {
  name: 'ShopForm',
  components: {
    ImageUploader,
    ShopDeleteDialog,
  },
  props: {
    companyId: {
      type: String,
      required: true,
    },
    shopId: {
      type: String,
    },
    shop: {
      type: Object,
    },
  },
  data: () => ({
    saving: false,
    deleting: false,
    formData: { ...DEFAULT_FORM },
    formValid: false,
    formRules: {
      required: [v => !!v],
    },
    isDeleteDialogOpen: false,
    logo: null,
  }),
  computed: mapState({
    selectedCompany: state => state.companies.selectedCompany,
  }),
  mounted() {
    if (this.shopId && this.shop) {
      this.setFormData(this.shop)
    }
  },
  methods: {
    setFormData(data) {
      this.formData = {
        ...data
      }
    },
    async onSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      if (!this.logo && !this.formData.logoImageUrl) {
        alert('กรุณาอัปโหลดรูปร้านค้า')
        return
      }
      this.saving = true
      try {
        let shopId
        if (this.shopId) {
          await this.$store.dispatch('shops/update', {
            companyId: this.companyId,
            data: {
              ...this.formData
            },
            logo: this.logo,
            id: this.shopId
          })
          shopId = this.shopId
        } else {
          shopId = await this.$store.dispatch('shops/create', {
            companyId: this.companyId,
            data: {
              ...this.formData
            },
            logo: this.logo
          })
        }
        this.$router.push({ name: 'Company.Settings.Shops', params: { shopId } })
      } catch (err) {
        console.error(err)
      }
      this.saving = false
    },
    onDeleteSuccess() {
      this.$router.push({ name: 'Company.Settings.Shops' })
    }
  }
}
</script>

<style lang="scss" scoped>
.shop-form {
  width: 580px;
}
</style>